<template>
    <div :id="$id('header')">
        <div class="row">
            <div class="col-md-10 col-sm-8">
                <h6 v-if="size === 'sm'">
                    <span v-html="this.name" />
                    <I18NImage :i18-n-pic-id="i18NPictureId" :pic-title="name" :i18-n-description="i18NDescription"/>
                </h6>
                <h5 v-if="size === 'md'">
                    <span v-html="this.name" />
                    <I18NImage :i18-n-pic-id="i18NPictureId" :pic-title="name" :i18-n-description="i18NDescription"/>
                </h5>
                <h4 v-if="size === 'lg'">
                    <span v-html="this.name" />
                    <I18NImage :i18-n-pic-id="i18NPictureId" :pic-title="name" :i18-n-description="i18NDescription"/>
                </h4>
            </div>
            <div class="col-md-2 col-sm-4">
                <div class="float-right">
                    <b-button :id="$id('resetButton')" class="btn btn-light" v-on:click="resetElements()"
                              :style="'visibility:' + visibility">
                        <b-icon-x/>
                    </b-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import I18NImage from "@/components/config-page/utils/I18NImage";

    export default {
        name: 'Header',
        components: {I18NImage},
        props: {
            name: {
                type: String,
                required: true
            },
            visible: {
                type: Boolean,
                default: true
            },
            size: {
                type: String,
                default: 'md'
            },
            i18NPictureId: {
                required: false,
                default: null
            },
            i18NDescription: {
                required: false,
                default: null
            }
        },
        computed: {
          visibility: function () {
              return this.$props.visible ? 'visible' : 'hidden';
          }
        },
        methods: {
            resetElements() {
                this.$emit('reset-elements');
            }
        }
    }
</script>

<style scoped>

    .btn-light {
        background: none;
        border: none;
        padding: 0px;
    }

    .btn-light :hover {
        color: lightcoral;
    }

</style>